import { of } from "rxjs";
import { mergeMap, map } from 'rxjs/operators';
import { combineEpics, ofType } from "redux-observable";

import { LOCATION_CHANGE, push } from "connected-react-router";
import * as authActionTypes from "auth/authActionTypes";
import * as applicationActionTypes from "application/redux/applicationActionTypes";
import {
  errorOccurred,
  routeChanged,
} from "application/redux/applicationActions";

const ERROR_PATH = "/error";
const LOGIN_PATH = "/login";

const authLogInEpic = action$ =>
  action$.pipe(
    ofType(authActionTypes.LOG_IN),
    mergeMap(action => of(push(LOGIN_PATH)))
  );

// application depends on auth not the other way around
const authErrorEpic = action$ =>
  action$.pipe(
    ofType(authActionTypes.AUTH_ERROR),
    map(action => errorOccurred(action.error))
);

const authRedirectEpic = action$ =>
  action$.pipe(
    ofType(authActionTypes.AUTH_REDIRECT),
    mergeMap(action => of(push(LOGIN_PATH)))
  );

const errorEpic = action$ =>
  action$.pipe(
    ofType(applicationActionTypes.ERROR_OCCURRED),
    mergeMap(action => of(push(ERROR_PATH)))
  );

// normalize here in case something changes
const routeChangedEpic = action$ =>
  action$.pipe(
    ofType(LOCATION_CHANGE),
    map(action => routeChanged(action.payload.location.pathname))
  );

export default combineEpics(
  authLogInEpic,
  authErrorEpic,
  authRedirectEpic,
  errorEpic,
  routeChangedEpic,
);
